import i18n from '../../utils/localizations.jsx';

export const actions = {
    SET_USER: "SET_APP_USER",
    START_REQUEST: "START_REQUEST",
    SET_APP_SETTINGS: "SET_APP_SETTINGS",
    HANDLE_ERROR: "HANDLE_ERROR",
    CLEAR_ERROR: "CLEAR_ERROR",
    END_REQUEST: "END_REQUEST",
    CHANGE_APP_LANGUAGE: "CHANGE_LANGUAGE",
    SET_LOADING: "APP_LOADING",
    SET_READY: "SET_APP_READY",
    CLEAR_STATE: "App.CLEAR_STATE"
};

const initialState = {
    user: null,
    appLanguage: "",//i18n.language,
    deviceTypes: [],
    ioTypes: [],
    ioActionTypes: [],
    applicationSettings: [],
    appModulesAccess: [],
    appFieldsAccess: [],
    ready: false,
    loading: false,
    error: {}
};

export default function reducer(state, action) {
    state = state || initialState;

    switch (action.type) {
        case actions.SET_USER:        
        {
            const {user} = action;
            return{
                ...state,
                user: user
            }
        }
        case actions.SET_LOADING:
            {
                const {loading} = action;
                return {
                    ...state,
                    loading: loading
                };
            }
        case actions.SET_READY:
            {
                const {ready} = action;
                return {
                    ...state,
                    ready: ready
                };
            }
        case actions.SET_APP_SETTINGS:
            {
                return {
                    ...state,
                    deviceTypes: action.appSettings.deviceTypes,
                    ioTypes: action.appSettings.ioTypes,
                    ioActionTypes: action.appSettings.ioActionTypes,
                    appModulesAccess: action.appSettings.appModulesAccess,
                    appFieldsAccess: action.appSettings.appFieldsAccess,
                    applicationSettings: action.appSettings.applicationSettings,
                    loading: false,
                    ready: true
                };
            }
        case actions.HANDLE_ERROR:
            {
                return {
                    ...state,
                    error: action.error,
                    loading: false
                };
            }
        case actions.CLEAR_ERROR:
            {
                return {
                    ...state,
                    error: {}
                };
            }
        case actions.CHANGE_APP_LANGUAGE:
            {
                return {
                    ...state,
                    appLanguage: action.language,
                    loading: false
                };
            }
        case actions.CLEAR_STATE:{
            return {
                ...state,
                deviceTypes: [],
                ioTypes: [],
                ioActionTypes: [],
                applicationSettings: [],
                appModulesAccess: [],
                appFieldsAccess: [],
                ready: false,
            }
        }
        default:
            return state;
    }
};

export const setAppUser = (user) => ({type: actions.SET_USER, user});
export const setLoading = (loading) => ({type: actions.SET_LOADING, loading});
export const setReady = (ready) => ({type: actions.SET_READY, ready});
export const setAppSettings = (appSettings) => ({type: actions.SET_APP_SETTINGS, appSettings});
export const clearState = () => ({type: actions.CLEAR_STATE});